import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Hidden from '@material-ui/core/Hidden';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/api.reports.search.actions';
import * as home from '../../../../actions/process.home.actions';

import Query from './Menu';
import Menu from '../Menu';
import List from './List';
import Error from '../../../dialogs/Error';
import Loading from '../../../dialogs/loading';

// eslint-disable-next-line
import style from './_styles.css';

class Catalogs extends React.Component {
    state = {
        hide: false,
        open: undefined,
        error: undefined,
    };

    componentDidMount() {
        if (!this.props.result) {
            this.props
                .loadFields()
                .catch((error) => {
                    console.log(error);
                    this.setState({ error: error.message, errorType: error.type });
                });
        }
    }

    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    };

    handleBack = () => {
        if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    };

    render() {
        const { info, result, report_search_is_loading } = this.props;
        const { error, errorType } = this.state;
        if (
            info &&
            info.security &&
            info.security.totalPermits &&
            !(info.security.totalPermits.some((f) => f === '20' || f === '60') &&
              info.security.licencias.some((f) => f.id === 150 && f.activo ))
        ) {
            return <Error open id={'unauthorized_access'} handleClose={this.handleBack} />;
        } else if (error) {
            return <Error open type={errorType} message={error} handleClose={this.handleBack} />;
        } else {
            return (
                <div className={'flex_full_row heigth100 bg_ice_blue'}>
                    {report_search_is_loading && <Loading open opacity />}
                    {!result
                        ? <React.Fragment>
                            <Hidden xsDown>
                                <div className={'flex_20 overflow_y_scroll padding_top_12 shadow_right_on_tablet bg_white'} >
                                    <Menu {...this.props} active="search" />
                                </div>
                            </Hidden>
                            <div className={'flex_full bg_white center'} >
                                <Query {...this.props} />
                            </div>
                        </React.Fragment>
                        : <List {...this.props} />
                    }
                </div>
            );
        }
    }
}

Catalogs.propTypes = {
    catalog_is_loading: PropTypes.bool.isRequired,
    report_search_is_loading: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
    return {
        catalog_is_loading: state.catalog_is_loading,
        report_search_is_loading: state.report_search_is_loading,
        info: state.info,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions, home), dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(Catalogs));



// WEBPACK FOOTER //
// ./src/components/complex/reports/search/Index.js